import { ChevronDown, User, Headset, LogOut } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Separator } from "../ui/separator";
import { Button } from "../ui/button";
import { LogOutDialog } from "../dialog/utils-dialog";
import { Link, useNavigate } from "react-router-dom";
import { blackUser } from "@/assets";

export function NavUser({ user }) {
  const [openDialog, setOpenDialog] = useState(false);
  const navigate = useNavigate();

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const handleLogout = () => {
    navigate("/auth/login");
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="hover:bg-transparent !ring-0 select-none flex  gap-3 items-center">
          <Avatar className="h-8 w-8 rounded-lg text-cwhite">
            <AvatarImage
              className="h-full w-full object-cover"
              src={user?.file_manager_url || blackUser}
              alt={user?.name}
            />
            <AvatarFallback className="rounded-lg bg-darkGray">
              {" "}
              {user?.name?.charAt(0) || "U"}
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight text-white">
            <span className="truncate font-semibold">{user?.name}</span>
            <span className="truncate text-xs capitalize">{user?.designation || "N/A"}</span>
          </div>
          <ChevronDown className="ml-auto size-4 text-white" />
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-60 mt-3 bg-cblack3">
        <div
          onClick={() => navigate("/backoffice/my-account")}
          className="!ring-0 select-none flex  gap-3 items-center cursor-pointer"
        >
          <Avatar className="h-8 w-8 rounded-lg text-cwhite">
            <AvatarImage
              className="h-full w-full object-cover"
              src={user?.file_manager_url || blackUser}
              alt={user?.name}
            />
            <AvatarFallback className="rounded-lg bg-darkGray">
              {" "}
              {user?.name?.charAt(0) || "U"}
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight text-white">
            <span className="truncate font-semibold">{user?.name}</span>
            <span className="truncate text-xs capitalize">{user?.designation || "N/A"}</span>
          </div>
        </div>
        <Separator className="mt-4" />
        <div className="space-y-3 text-cwhite2 mt-3">
          <Link to={"/backoffice/my-account"}>
            <div className="flex justify-start items-center gap-2 text-sm cursor-pointer">
              <User />
              My Account
            </div>
          </Link>
          <div className="flex justify-start items-center gap-2 text-sm cursor-pointer">
            {" "}
            <Headset /> Support{" "}
          </div>
        </div>
        <div className="mt-6">
          <Button
            onClick={() => setOpenDialog(true)}
            className="w-full bg-cyellow/5 border-none text-cyellow"
          >
            <LogOut size={20} />
            Log out
          </Button>
          <LogOutDialog isOpen={openDialog} onClose={closeDialog} />
        </div>
      </PopoverContent>
    </Popover>
  );
}
